import { atomWithReset } from 'jotai/utils';

/**
 * Ordenação disponível para a lista de categorias/slides na biblioteca.
 */
export type LibrarySortBy = 'title' | 'recent';

/**
 * Estado dos filtros da biblioteca de slides.
 * `searchQuery` é o valor atual do input (pendente).
 * `appliedQuery` é o valor efetivamente aplicado ao clicar em "Buscar".
 */
export interface LibraryFilters {
  readonly searchQuery: string;
  readonly appliedQuery: string;
  readonly appliedCategoryId: number | null;
  readonly sortBy: LibrarySortBy;
}

const DEFAULT_FILTERS: LibraryFilters = {
  searchQuery: '',
  appliedQuery: '',
  appliedCategoryId: null,
  sortBy: 'recent',
};

/**
 * Átomo de filtros da biblioteca. Não é persistido — reseta ao recarregar a página.
 */
export const libraryFiltersAtom = atomWithReset<LibraryFilters>(DEFAULT_FILTERS);
libraryFiltersAtom.debugLabel = 'slide-libary/libraryFiltersAtom';
